module.exports = __webpack_public_path__ + "static/media/DownloadIcon.d96044ff.svg";